export const ContactStatusTypes = [
  { id: 4, name: 'Active', description: 'Actively working with client on a sale.' },
  { id: 6, name: 'Closed/Inactive', description: 'Completed a transaction.' },
  { id: 3, name: 'Future', description: 'Send future marketing and emails to.' },
  { id: 1, name: 'New', description: 'New client, haven\'t yet contacted.' },
  { id: 5, name: 'Non-Client', description: 'Not a client.' },
  { id: 2, name: 'Prospecting', description: 'Tried contacting client, no response yet.' },
  { id: 7, name: 'Soon', description: '(Temporary)' },
];
